import React, { Component } from 'react'
import { Card, Col, Row } from "reactstrap";
// import Table from "./Table";
import PieChart from "./charts/PieChart";
import BarChart from "./charts/BarChart";
import StackedBar from "./charts/StackedBar";
import MiniKPITrendline from "./charts/MiniKPITrendline";
// import MultiType from "./charts/MultiType";
import MultiType from "./charts/MultiType";
import Line from "./charts/Line";
import FloatingBar from "./charts/FloatingBar";
import MiniKpi from "./charts/MiniKpi";
import Area from "./charts/Area";
import RadialChart from "./charts/RadialBar";
import Gauge from "./charts/Gauge";
function Chart(props){

  console.log("------------------->"+props.prams.chartType)
  console.log(props.ChartTypes[props.prams.chartType])
      
  return(
    <>
      <div className='cockpitChart'>
      {/* <StackedBarChart prams={props} /> */}
           {(() => {
                switch(props.ChartTypes[props.prams.chartType]) {
                    case "Pie":
                        return (
                          <PieChart prams={props} />
                        )
                    case "Bar":
                        return (
                              <BarChart prams={props}/>
                            )
                    case "StackedBar":
                        return (
                              <BarChart prams={props}/>
                            )                            
                    case "Donut":
                         return (
                           <PieChart prams={props}/>
                     )    
                     case "MultiType":
                      return (
                        <BarChart prams={props}/>
                     )
                     case "Stacked Bar":
                      return (
                        <BarChart prams={props}/>
                     )
                     case "Area":
                      return (
                        <Area prams={props}/>
                     )     
                     case "Area with Line":
                      return (
                        <Area prams={props}/>
                     )      
                     case "Line":
                         return (
                           <Line prams={props}/>
                     ) 
                     case "Bar with Line":
                         return (
                           <BarChart prams={props}/>
                     ) 
                     case "Multi Axis":
                         return (
                           <BarChart prams={props}/>
                     ) 
                     case "Gauge":
                         return (
                           <Gauge prams={props}/>
                     )   
                     case "Mini KPI":
                         return (
                           <MiniKpi prams={props}/>
                     )   
                     case "RadialBar":
                         return (
                           <RadialChart prams={props}/>
                     )    
                     case "Mini KPI with Trendline":
                         return (
                           <MiniKPITrendline prams={props}/>
                     )    
                     //FloatingBar
                      default:    
                    return (
                        <>
                          <div className='Polar'>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='componentNameC'>Component Not Found</div>
                              </div>
                            </div>
                            <div className="p-4 Polar1" style={{      
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexDirection: 'column',
                              height: '100vh', // Optionally set a height to center vertically in the viewport
                              color: '#85929E'}}>
                               {props.ChartTypes[props.prams.chartType]} Chart Not Found                                
                            </div>
                          </div>                        
                        </>
                  )
                }
            })()}
      </div>
    </>
  )
}
export default Chart